import React from 'react';

import { LinkedIn, Pinterest } from '@mui/icons-material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Box, IconButton, Link, Typography } from '@mui/material';

import { useConfig } from '../ConfigContext';

const Footer: React.FC = () => {
  const { config } = useConfig();
  if (!config) {
    return null;
  }

  const { title, subtitle, bottomText, links, customLinks } =
    config.footerConfig;
  const theme = config.theme;
  const footerStyles = theme.components?.Footer?.styleOverrides?.root || {};

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
        padding: '100px 70px',
        background:
          footerStyles.backgroundColor || theme.palette.secondary.main,
        color: footerStyles.color || theme.palette.secondary.contrastText,
      }}
    >
      {/* Text Before Links */}
      {title && <Typography variant="h6">{title}</Typography>}
      {subtitle && <Typography variant="body1">{subtitle}</Typography>}

      {/* Social Media Links */}
      {links && (
        <Box sx={{ mt: 2, display: 'flex', gap: 5 }}>
          {links.instagram && (
            <IconButton
              href={links.instagram}
              target="_blank"
              aria-label="Instagram"
              sx={{ color: 'inherit' }}
            >
              <InstagramIcon />
            </IconButton>
          )}
          {links.facebook && (
            <IconButton
              href={links.facebook}
              target="_blank"
              aria-label="Facebook"
              sx={{ color: 'inherit' }}
            >
              <FacebookIcon />
            </IconButton>
          )}
          {links.x && (
            <IconButton
              href={links.x}
              target="_blank"
              aria-label="X"
              sx={{ color: 'inherit' }}
            >
              <XIcon />
            </IconButton>
          )}
          {links.youtube && (
            <IconButton
              href={links.youtube}
              target="_blank"
              aria-label="YouTube"
              sx={{ color: 'inherit' }}
            >
              <YouTubeIcon />
            </IconButton>
          )}
          {links.linkedin && (
            <IconButton
              href={links.linkedin}
              target="_blank"
              aria-label="LinkedIn"
              sx={{ color: 'inherit' }}
            >
              <LinkedIn />
            </IconButton>
          )}
          {links.pinterest && (
            <IconButton
              href={links.pinterest}
              target="_blank"
              aria-label="Pinterest"
              sx={{ color: 'inherit' }}
            >
              <Pinterest />
            </IconButton>
          )}
        </Box>
      )}

      {/* Custom Links */}
      {customLinks && customLinks.length > 0 && (
        <Box sx={{ mt: 3, display: 'flex', gap: 3, flexWrap: 'wrap' }}>
          {customLinks.map((link, index) => (
            <Link
              key={index}
              href={link.url}
              color="inherit"
              underline="hover"
              sx={{ fontWeight: 'bold' }}
            >
              {link.title}
            </Link>
          ))}
        </Box>
      )}

      {/* Text After Links */}
      {bottomText && (
        <Typography variant="body1" sx={{ mt: 4 }}>
          {bottomText}
        </Typography>
      )}
    </Box>
  );
};

export default Footer;
